export default "__VITE_ASSET__CkapP082__"